module.exports = __webpack_public_path__ + "img/ic-blokk.be557d2e.svg";